import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { SymbolService } from '../service/symbolService';

export const symbolInitializationGuard: CanActivateFn = () => {
    const symbolService = inject(SymbolService);

    return symbolService.init().pipe(
        map(() => true)
        // Fehlerfall: ErrorInterceptor/GlobalErrorHandler übernimmt,
        // oder hieruell snackBar + return false:
    );
};